import { ArrowUpRight, Clock } from "lucide-react";
import { Reveal } from "./Reveal";

const onMove = (e) => {
  const r = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
  e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
};

const Status = ({ live, label }) => (
  <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 font-mono text-[11px] uppercase tracking-widest ${live ? "border-[#22C55E]/30 text-[#22C55E]" : "border-[#F59E0B]/30 text-[#F59E0B]"}`}>
    {live ? <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#22C55E]" /> : <Clock className="h-3 w-3" />}
    {label}
  </span>
);

export const ProjectCard = ({ p, index, className, featured, soon }) => {
  const live = p.href && p.href !== "#";
  const Icon = p.icon;
  return (
    <Reveal delay={index * 0.08} className={className}>
      <article onMouseMove={onMove} className="rb-card group relative flex h-full flex-col overflow-hidden rounded-3xl p-7 hover:-translate-y-0.5 sm:p-9" data-testid={`project-card-${p.id}`}>
        <div className="spot pointer-events-none absolute inset-0" />
        {featured && <span className="pointer-events-none absolute right-6 top-16 font-display text-[7rem] font-black leading-none tracking-tighter text-transparent transition-transform duration-700 [-webkit-text-stroke:1px_rgba(139,92,246,0.4)] group-hover:-translate-y-2 sm:text-[12rem] lg:top-10 lg:text-[15rem]">P2P</span>}
        <div className="relative flex items-start justify-between gap-4">
          <span className="grid h-12 w-12 place-items-center rounded-2xl border border-[var(--line)] bg-[#8B5CF6]/10 text-[var(--violet-h)] transition-transform duration-500 group-hover:rotate-[-8deg] group-hover:scale-110">
            <Icon className="h-5 w-5" />
          </span>
          <Status live={live} label={p.status} />
        </div>
        <div className="relative mt-auto pt-12">
          <span className="font-mono text-xs text-[var(--faint)]">0{index + 1}</span>
          <h3 className={`mt-2 font-display font-black tracking-tight ${featured ? "text-4xl sm:text-5xl lg:text-6xl" : "text-2xl"}`}>{p.name}</h3>
          <p className={`mt-3 leading-relaxed text-[var(--muted)] ${featured ? "max-w-md text-base" : "text-sm"}`}>{p.desc}</p>
          {p.stats && (
            <dl className="mt-8 grid max-w-md grid-cols-3 gap-4 border-t border-[var(--line)] pt-6">
              {p.stats.map((s) => (
                <div key={s.label}>
                  <dt className="font-mono text-2xl font-semibold text-[var(--text)] sm:text-3xl">{s.value}</dt>
                  <dd className="mt-1 text-xs text-[var(--muted)]">{s.label}</dd>
                </div>
              ))}
            </dl>
          )}
          {live ? (
            <a href={p.href} target="_blank" rel="noopener noreferrer" data-testid={`project-visit-${p.id}`} className="pill-primary mt-8 inline-flex items-center gap-2 rounded-full px-5 py-3 text-sm font-semibold">
              {p.cta} <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          ) : (
            <span data-testid={`project-visit-${p.id}`} aria-disabled="true" className="mt-8 inline-flex cursor-not-allowed items-center gap-2 rounded-full border border-dashed border-[var(--line)] px-5 py-3 text-sm font-semibold text-[var(--muted)]">
              {soon} →
            </span>
          )}
        </div>
      </article>
    </Reveal>
  );
};
